const root={
  auth: '/auth',
  courses: '/courses',
  modules: '/modules',
  categories: '/categories',
  module_blocks: '/module-blocks',
  quiz: '/quiz',
  fineopay: '/fineopay'
}

export const endpoints = {
  // Authentication
  login: `${root.auth}/login`,
  register: `${root.auth}/register`,
  logout: `${root.auth}/logout`,
  refreshToken: `${root.auth}/refresh-token`,
  user: `${root.auth}/profile`,
  updatePreferredLanguage: `/users/me/preferred-language`,
  verifyEmail: `${root.auth}/verify-email`,
  forgotPassword: `${root.auth}/forgot-password`,
  resetPassword: `${root.auth}/reset-password`,
  changePassword: `${root.auth}/change-password`,
  
  // Users management
  users: `/users`,
  createUser: `/users`,
  getUser: (userId) => `/users/${userId}`,
  updateUser: (userId) => `/users/${userId}`,
  updateUserAdmin: (userId) => `/users/${userId}/admin`,
  deleteUser: (userId) => `/users/${userId}`,
  updateAvatar: `/users/me/avatar`,
  uploadImage: `/upload/image`,
  cloudinaryUpload: `/cloudinary/upload`,
  usersExport: `/users/export`,
  
  // Courses management
  courses: `/courses`,
  createCourse: `/courses`,
  getCourse: (courseId) => `/courses/${courseId}`,
  getCourseDetails: (courseId) => `/courses/${courseId}/details`,
  updateCourse: (courseId) => `/courses/${courseId}`,
  deleteCourse: (courseId) => `/courses/${courseId}`,
  coursesFeatured: `/courses/featured`,
  coursesPopular: `/courses/popular`,
  courseBySlug: (slug) => `/courses/slug/${slug}`,
  publishCourse: (courseId) => `/courses/${courseId}/publish`,
  unpublishCourse: (courseId) => `/courses/${courseId}/unpublish`,
  courseEnroll: (courseId) => `/courses/${courseId}/enroll`,
  courseProgressById: (courseId) => `/courses/${courseId}/progress`,
  courseStudents: (courseId) => `/courses/${courseId}/students`,
  courseHierarchy: (courseId) => `/courses/${courseId}/hierarchy`,
  
  // Categories management
  categories: `/categories`,
  createCategory: `/categories`,
  getCategories: `/categories`,
  getCategory: (categoryId) => `/categories/${categoryId}`,
  updateCategory: (categoryId) => `/categories/${categoryId}`,
  deleteCategory: (categoryId) => `/categories/${categoryId}`,
  // Note: categoriesWithCourseCount est remplacé par getCategories avec le paramètre language
  categoriesPopular: `/categories/popular`,
  categoriesSearch: `/categories/search`,
  categoryByName: (name) => `/categories/name/${name}`,
  
  // Category Translations
  createCategoryTranslation: (categoryId) => `/categories/${categoryId}/translations`,
  getCategoryTranslations: (categoryId) => `/categories/${categoryId}/translations`,
  getCategoryTranslation: (categoryId, language) => `/categories/${categoryId}/translations/${language}`,
  updateCategoryTranslation: (categoryId, language) => `/categories/${categoryId}/translations/${language}`,
  deleteCategoryTranslation: (categoryId, language) => `/categories/${categoryId}/translations/${language}`,

  // Modules management
  modules: `/modules`,
  createModule: `/modules`,
  getModule: (moduleId) => `/modules/${moduleId}`,
  updateModule: (moduleId) => `/modules/${moduleId}`,
  deleteModule: (moduleId) => `/modules/${moduleId}`,
  publishModule: (moduleId) => `/modules/${moduleId}/publish`,
  unpublishModule: (moduleId) => `/modules/${moduleId}/unpublish`,
  moveModuleUp: (moduleId) => `/modules/${moduleId}/move-up`,
  moveModuleDown: (moduleId) => `/modules/${moduleId}/move-down`,
  
  // Module lessons management
  moduleLessons: `/module-lessons`,
  createModuleLesson: `/module-lessons`,
  getModuleLesson: (lessonId) => `/module-lessons/${lessonId}`,
  updateModuleLesson: (lessonId) => `/module-lessons/${lessonId}`,
  deleteModuleLesson: (lessonId) => `/module-lessons/${lessonId}`,
  publishModuleLesson: (lessonId) => `/module-lessons/${lessonId}/publish`,
  unpublishModuleLesson: (lessonId) => `/module-lessons/${lessonId}/unpublish`,
  lessonContent: (lessonId) => `/module-lessons/${lessonId}/content`,
  
  // Module blocks management
  module_blocks: `/module-blocks`,
  // alias camelCase pour éviter les erreurs d'import
  moduleBlocks: `/module-blocks`,
  createModuleBlock: `/module-blocks`,
  getModuleBlock: (blockId) => `/module-blocks/${blockId}`,
  updateModuleBlock: (blockId) => `/module-blocks/${blockId}`,
  deleteModuleBlock: (blockId) => `/module-blocks/${blockId}`,
  reorderLessonBlocks: (lessonId) => `/module-blocks/lessons/${lessonId}/reorder`,
  
  // Quiz management
  quiz: `/quiz`,
  createQuiz: `/quiz`,
  getQuiz: (quizId) => `/quiz/${quizId}`,
  getQuizAdmin: (quizId) => `/quiz/admin/${quizId}`,
  updateQuiz: (quizId) => `/quiz/${quizId}`,
  deleteQuiz: (quizId) => `/quiz/${quizId}`,
  createQuizQuestion: (quizId) => `/quiz/${quizId}/questions`,
  quizComplete: (quizId) => `/quiz/${quizId}/complete`,
  quizStudent: (quizId) => `/quiz/${quizId}/student`,
  publishQuiz: (quizId) => `/quiz/${quizId}/publish`,
  unpublishQuiz: (quizId) => `/quiz/${quizId}/unpublish`,
  quizStats: (quizId) => `/quiz/${quizId}/stats`,
  quizAttempt: (quizId) => `/quiz/${quizId}/attempt`,
  startQuizAttempt: (quizId) => `/quiz/${quizId}/attempt/start`,
  quizAttempts: `/quiz/attempts`,
  myQuizAttempts: `/quiz/attempts/my`,
  quizAttemptById: (attemptId) => `/quiz/attempts/${attemptId}`,
  cancelQuizAttempt: (quizId) => `/quiz/${quizId}/attempt/cancel`,
  quizAnalytics: (quizId) => `/quiz/${quizId}/analytics`,
  
  // Enrollments
  enrollments: `/enrollments`,
  createEnrollment: `/enrollments`,
  getEnrollment: (enrollmentId) => `/enrollments/${enrollmentId}`,
  updateEnrollment: (enrollmentId) => `/enrollments/${enrollmentId}`,
  deleteEnrollment: (enrollmentId) => `/enrollments/${enrollmentId}`,
  checkEnrollment: (courseId) => `/enrollments/check/${courseId}`,
  checkAccess: (courseId) => `/enrollments/check-access/${courseId}`,
  myCourses: `/enrollments/my-courses`,
  
  // Enrollments - Admin
  adminCourseUsers: (courseId) => `/enrollments/admin/course/${courseId}/users`,
  adminEnrollmentAccess: (enrollmentId) => `/enrollments/${enrollmentId}/manage-access`,
  adminDeleteEnrollment: (enrollmentId) => `/enrollments/admin/enrollment/${enrollmentId}`,
  adminActivateCourse: `/enrollments/admin/activate-course`,
  
  // Progress
  courseProgress: `/course-progress/courses`,
  createCourseProgress: `/course-progress/courses`,
  getCourseProgress: (courseId) => `/course-progress/courses/${courseId}`,
  updateCourseProgress: (courseId) => `/course-progress/courses/${courseId}`,
  recalculateCourseProgress: (courseId) => `/course-progress/courses/${courseId}/recalculate`,
  startCourse: (courseId) => `/course-progress/courses/${courseId}/start`,
  
  blockProgress: `/course-progress/blocks`,
  createBlockProgress: `/course-progress/blocks`,
  getBlockProgress: (blockId) => `/course-progress/blocks/${blockId}`,
  updateBlockProgress: (blockId) => `/course-progress/blocks/${blockId}`,
  startBlock: (blockId) => `/course-progress/blocks/${blockId}/start`,
  completeBlock: (blockId) => `/course-progress/blocks/${blockId}/complete`,
  
  // Lesson progress
  completeLesson: (lessonId) => `/course-progress/lessons/${lessonId}/complete`,
  
  // Progress Analytics
  myProgressOverview: `/progress-analytics/my/overview`,
  myQuizHistory: `/progress-analytics/my/quiz-history`,
  myRecommendations: `/progress-analytics/my/recommendations`,
  courseDetailedAnalytics: (courseId) => `/progress-analytics/courses/${courseId}/detailed`,
  courseStudentProgress: (courseId) => `/progress-analytics/courses/${courseId}/student-progress`,
  courseModuleAnalytics: (courseId) => `/progress-analytics/courses/${courseId}/module-analytics`,

  //fineopay
  coursePayment: `${root.fineopay}/course-payment`,
  checkoutLink: `${root.fineopay}/checkout-link`,
  adminPayments: `${root.fineopay}/admin/payments`,
  adminPaymentStats: `${root.fineopay}/admin/stats`,
  
  // Certificates
  certificates: `/certificates`,
  myCertificates: `/certificates/my-certificates`,
  getCertificate: (certificateId) => `/certificates/${certificateId}`,
  downloadCertificate: (certificateId) => `/certificates/${certificateId}/download`,
  getCertificateByCourse: (courseId) => `/certificates/course/${courseId}`,
  
  // Course Reviews
  submitCourseReview: (courseId) => `/course-reviews/courses/${courseId}`,
  
  // Health
  health: `/health`,
  healthStatus: `/health/status`,
  
  // Access verification
  verifyCourseAccess: (courseId) => `/courses/${courseId}/verify-access`,
  verifyModuleAccess: (moduleId) => `/modules/${moduleId}/verify-access`,
  verifyLessonAccess: (lessonId) => `/module-lessons/${lessonId}/verify-access`,
  verifyBlockAccess: (blockId) => `/module-blocks/${blockId}/verify-access`,
  verifyQuizAccess: (quizId) => `/quiz/${quizId}/verify-access`,
  
  // Translations
  // Course translations
  createCourseTranslation: (courseId) => `/translations/courses/${courseId}`,
  getCourseTranslations: (courseId) => `/translations/courses/${courseId}`,
  getCourseTranslation: (courseId, language) => `/translations/courses/${courseId}/${language}`,
  updateCourseTranslation: (courseId, language) => `/translations/courses/${courseId}/${language}`,
  deleteCourseTranslation: (courseId, language) => `/translations/courses/${courseId}/${language}`,
  getCourseLanguages: (courseId) => `/translations/courses/${courseId}/languages`,
  
  // Module translations
  createModuleTranslation: (moduleId) => `/translations/modules/${moduleId}`,
  getModuleTranslations: (moduleId) => `/translations/modules/${moduleId}`,
  getModuleTranslation: (moduleId, language) => `/translations/modules/${moduleId}/${language}`,
  updateModuleTranslation: (moduleId, language) => `/translations/modules/${moduleId}/${language}`,
  deleteModuleTranslation: (moduleId, language) => `/translations/modules/${moduleId}/${language}`,
  getModuleLanguages: (moduleId) => `/translations/modules/${moduleId}/languages`,
  // Nouveaux endpoints qui retournent directement les modules/blocs traduits
  getTranslatedModules: (courseId, language) => `/translations/modules?courseId=${courseId}&language=${language}`,
  getTranslatedModuleBlocks: (moduleId, language) => `/translations/module-blocks?moduleId=${moduleId}&language=${language}`,
  
  // Block translations
  createBlockTranslation: (blockId) => `/translations/blocks/${blockId}`,
  getBlockTranslations: (blockId) => `/translations/blocks/${blockId}`,
  getBlockTranslation: (blockId, language) => `/translations/blocks/${blockId}/${language}`,
  updateBlockTranslation: (blockId, language) => `/translations/blocks/${blockId}/${language}`,
  deleteBlockTranslation: (blockId, language) => `/translations/blocks/${blockId}/${language}`,
  getBlockLanguages: (blockId) => `/translations/blocks/${blockId}/languages`,
  
  // Lesson translations
  createLessonTranslation: (lessonId) => `/translations/lessons/${lessonId}`,
  getLessonTranslations: (lessonId) => `/translations/lessons/${lessonId}`,
  getLessonTranslation: (lessonId, language) => `/translations/lessons/${lessonId}/${language}`,
  updateLessonTranslation: (lessonId, language) => `/translations/lessons/${lessonId}/${language}`,
  deleteLessonTranslation: (lessonId, language) => `/translations/lessons/${lessonId}/${language}`,
  getLessonLanguages: (lessonId) => `/translations/lessons/${lessonId}/languages`,
  
  // Quiz translations
  createQuizTranslation: (quizId) => `/translations/quizzes/${quizId}`,
  getQuizTranslations: (quizId) => `/translations/quizzes/${quizId}`,
  getQuizTranslation: (quizId, language) => `/translations/quizzes/${quizId}/${language}`,
  updateQuizTranslation: (quizId, language) => `/translations/quizzes/${quizId}/${language}`,
  deleteQuizTranslation: (quizId, language) => `/translations/quizzes/${quizId}/${language}`,
  getQuizLanguages: (quizId) => `/translations/quizzes/${quizId}/languages`,
  copyQuizTranslations: (quizId, language) => `/translations/quizzes/${quizId}/copy-translations${language ? `?language=${language}` : ''}`,
  
  // Quiz question translations
  createQuizQuestionTranslation: (questionId) => `/translations/quiz-questions/${questionId}`,
  getQuizQuestionTranslation: (questionId, language) => `/translations/quiz-questions/${questionId}/${language}`,
  copyQuizQuestionTranslations: (questionId, language) => `/translations/quiz-questions/${questionId}/copy-translations${language ? `?language=${language}` : ''}`,
  
  // Quiz option translations
  createQuizOptionTranslation: (optionId) => `/translations/quiz-options/${optionId}`,
  getQuizOptionTranslation: (optionId, language) => `/translations/quiz-options/${optionId}/${language}`,
  
  // Certificate translations
  createCertificateTranslation: (certificateId) => `/translations/certificates/${certificateId}`,
  getCertificateTranslations: (certificateId) => `/translations/certificates/${certificateId}`,
  getCertificateTranslation: (certificateId, language) => `/translations/certificates/${certificateId}/${language}`,
  updateCertificateTranslation: (certificateId, language) => `/translations/certificates/${certificateId}/${language}`,
  deleteCertificateTranslation: (certificateId, language) => `/translations/certificates/${certificateId}/${language}`,
  
  // Comments
  comments: `/comments`,
  createComment: `/comments`,
  getComments: `/comments`,
  getComment: (commentId) => `/comments/${commentId}`,
  updateComment: (commentId) => `/comments/${commentId}`,
  deleteComment: (commentId) => `/comments/${commentId}`,
  likeComment: (commentId) => `/comments/${commentId}/like`,
  unlikeComment: (commentId) => `/comments/${commentId}/like`,
  pinComment: (commentId) => `/comments/${commentId}/pin`,
  getCommentStats: (courseId) => `/comments/course/${courseId}/stats`,
  
  // Webinars - User/Public APIs
  webinars: `/webinars`,
  getWebinar: (webinarId) => `/webinars/${webinarId}`,
  registerToWebinar: (webinarId) => `/webinars/${webinarId}/register`,
  cancelWebinarRegistration: (webinarId) => `/webinars/${webinarId}/register`,
  myWebinarRegistrations: `/webinars/my-registrations`,
  
  // Webinars - Admin APIs
  createWebinar: `/webinars/admin`,
  updateWebinar: (webinarId) => `/webinars/admin/${webinarId}`,
  deleteWebinar: (webinarId) => `/webinars/admin/${webinarId}`,
  getAllWebinarsAdmin: `/webinars/admin/all`,
  getWebinarRegistrations: (webinarId) => `/webinars/admin/${webinarId}/registrations`,
  
  // Speakers (Intervenants)
  speakers: `/speakers`,
  createSpeaker: `/speakers`,
  getSpeaker: (speakerId) => `/speakers/${speakerId}`,
  updateSpeaker: (speakerId) => `/speakers/${speakerId}`,
  deleteSpeaker: (speakerId) => `/speakers/${speakerId}`,
  
  // Webinar Translations
  createWebinarTranslation: (webinarId) => `/webinars/${webinarId}/translations`,
  getWebinarTranslations: (webinarId) => `/webinars/${webinarId}/translations`,
  getWebinarTranslation: (webinarId, language) => `/webinars/${webinarId}/translations/${language}`,
  updateWebinarTranslation: (webinarId, language) => `/webinars/${webinarId}/translations/${language}`,
  deleteWebinarTranslation: (webinarId, language) => `/webinars/${webinarId}/translations/${language}`,
  
  // Promo Codes
  validatePromoCode: `/promo-codes/validate`,
  promoCodes: `/promo-codes`,
  createPromoCode: `/promo-codes`,
  getPromoCode: (promoCodeId) => `/promo-codes/${promoCodeId}`,
  updatePromoCode: (promoCodeId) => `/promo-codes/${promoCodeId}`,
  deletePromoCode: (promoCodeId) => `/promo-codes/${promoCodeId}`,
  
  // FAQ - Public APIs
  faqs: `/faq`,
  faqsPublished: `/faq/published`,
  faqCategories: `/faq/categories`,
  getFAQ: (faqId) => `/faq/${faqId}`,
  incrementFAQView: (faqId) => `/faq/${faqId}/view`,
  submitFAQFeedback: (faqId) => `/faq/${faqId}/helpful`,
  
  // FAQ - Admin APIs
  createFAQ: `/faq`,
  updateFAQ: (faqId) => `/faq/${faqId}`,
  deleteFAQ: (faqId) => `/faq/${faqId}`,
  
  // FAQ Translations
  createFAQTranslation: (faqId) => `/faq/${faqId}/translations`,
  getFAQTranslations: (faqId) => `/faq/${faqId}/translations`,
  getFAQTranslation: (faqId, language) => `/faq/${faqId}/translations/${language}`,
  updateFAQTranslation: (faqId, language) => `/faq/${faqId}/translations/${language}`,
  deleteFAQTranslation: (faqId, language) => `/faq/${faqId}/translations/${language}`,

  // Contact - Public API
  sendContactMessage: `/contact`,

  // Contact - Admin APIs
  getContactMessages: `/contact`,
  getContactStats: `/contact/stats`,
  getContactMessage: (messageId) => `/contact/${messageId}`,
  markContactAsRead: (messageId) => `/contact/${messageId}/read`,
  markContactAsUnread: (messageId) => `/contact/${messageId}/unread`,
  replyToContact: (messageId) => `/contact/${messageId}/reply`,
  deleteContactMessage: (messageId) => `/contact/${messageId}`,

  // Newsletter - Public APIs
  subscribeNewsletter: `/newsletter/subscribe`,
  unsubscribeNewsletter: (token) => `/newsletter/unsubscribe/${token}`,

  // Newsletter - Admin APIs
  getNewsletterSubscribers: `/newsletter/subscribers`,
  getNewsletterStats: `/newsletter/stats`,
  getNewsletterCampaigns: `/newsletter/campaigns`,
  createNewsletterCampaign: `/newsletter/campaigns`,
  getNewsletterCampaign: (campaignId) => `/newsletter/campaigns/${campaignId}`,
  sendNewsletterCampaign: (campaignId) => `/newsletter/campaigns/${campaignId}/send`,
  deleteNewsletterCampaign: (campaignId) => `/newsletter/campaigns/${campaignId}`,

  // Newsletter - Tracking APIs
  trackNewsletterOpen: (recipientId) => `/newsletter/track/open/${recipientId}`,
  trackNewsletterClick: (recipientId) => `/newsletter/track/click/${recipientId}`,

  // Stats - Admin APIs
  statsOverview: `/stats/overview`,
  statsUsers: `/stats/users`,
  statsCourses: `/stats/courses`,
  statsEnrollments: `/stats/enrollments`,
  statsRevenue: `/stats/revenue`,
  statsEngagement: `/stats/engagement`,
  statsWebinars: `/stats/webinars`,
  statsNewsletter: `/stats/newsletter`,
  statsDashboard: `/stats/dashboard`,
  statsLearners: `/stats/learners`,
  statsLearnerDetails: (userId) => `/stats/learners/${userId}`,
  statsLearnerCourseProgress: (userId, courseId) =>
    `/stats/learners/${userId}/courses/${courseId}`,

  // Quiz - Admin reset attempts
  resetQuizAttempts: (quizId, userId) =>
    `/quiz/${quizId}/attempts/reset/${userId}`,
  resetCourseQuizAttempts: (courseId, userId) =>
    `/quiz/courses/${courseId}/attempts/reset/${userId}`,

  // Testimonials - Public APIs
  testimonials: `/testimonials`,
  testimonialsPublished: `/testimonials/published`,
  getTestimonial: (testimonialId) => `/testimonials/${testimonialId}`,

  // Testimonials - Admin APIs
  createTestimonial: `/testimonials`,
  updateTestimonial: (testimonialId) => `/testimonials/${testimonialId}`,
  deleteTestimonial: (testimonialId) => `/testimonials/${testimonialId}`,
  reorderTestimonials: `/testimonials/reorder`,
  toggleTestimonialFeatured: (testimonialId) => `/testimonials/${testimonialId}/toggle-featured`,
  toggleTestimonialPublished: (testimonialId) => `/testimonials/${testimonialId}/toggle-published`,
}